export enum ApiList {
  ControllerModel = 'ControllerModel',
  InputParamForCalc = 'InputParamForCalc',
  Rule = 'Rule',
  Report = 'Report',
  ContrCalcParam = 'ContrCalcParam',
  Controller = 'Controller',
  CalcParam = 'CalcParam',
  ScheduleRule = 'ScheduleRule',
  Schedule = 'Schedule',
  ObjectScheduleActionList = 'ObjectScheduleActionList',
  CalcValue = 'CalcValue',
  RuleInController = 'RuleInController',
  SDirCriticality = 'SDirCriticality',
  SetValueLog = 'SetValueLog',
  UserActivityLog = 'UserActivityLog',
  TypicalConfig = 'TypicalConfig',
  InitParams = 'InitParams',
  DeviceParamForRule = 'DeviceParamForRule',
  CommandLog = 'CommandLog',
  UserGroup = 'UserGroup',
  User = 'User',
  ObjRubric = 'ObjRubric',
  DeviceConnect = 'DeviceConnect',
  Unit = 'Unit',
  SysUser = 'SysUser',
  CalcParamForRule = 'CalcParamForRule',
  Signal = 'Signal',
  CollectorServer = 'CollectorServer',
  ChirpstackServer = 'ChirpstackServer',
  PbxServer = 'PbxServer',
  NbiotServer = 'NbiotServer',
  NotificationServer = 'NotificationServer',
  ControllersManagement = 'ControllersManagement',
  DeviceParam = 'DeviceParam',
  Channel = 'Channel',
  ControlProcedure = 'ControlProcedure',
  PredefinedParam = 'PredefinedParam',
  PredefinedValue = 'PredefinedValue',
  ObjectType = 'ObjectType',
  DeviceClassifier = 'DeviceClassifier',
  SDirObjectState = 'SDirObjectState',
  EventLog = 'EventLog',
  AdminLog = 'AdminLog',
  RuleAction = 'RuleAction',
  Command = 'Command',
  ContrDeviceParam = 'ContrDeviceParam',
  SDirParamState = 'SDirParamState',
  ParamCategory = 'ParamCategory',
  ScheduleAction = 'ScheduleAction',
  Measure = 'Measure',
  ProcCondition = 'ProcCondition',
  Object = 'Object',
  Zone = 'Zone',
  GeoZone = 'GeoZone',
  Event = 'Event',
  SDirFunction = 'SDirFunction',
  Device = 'Device',
  SDirRole = 'SDirRole',
  OAuth2 = 'OAuth2',
  Dashboard = 'Dashboard',
  ExDashboard = 'ExDashboard',
  Widget = 'Widget',
  ExWidget = 'ExWidget',
  Metrics = 'Metrics',
  WgItemType = 'WgItemType',
  WgConfig = 'WgConfig',
  WgItemConfig = 'WgItemConfig',
  WgParam = 'WgParam',
  WgConfigValue = 'WgConfigValue',
  WgItem = 'WgItem',
  MeasureInterval = 'MeasureInterval',
  CalcInterval = 'CalcInterval',
  UserNotify = 'UserNotify',
  NotifyLog = 'NotifyLog',
  NotifyMsg = 'NotifyMsg',
  Subscription = 'Subscription',
  NotifyMethod = 'NotifyMethod',
  IconSet = 'IconSet',
  DeviceParamStateIcon = 'DeviceParamStateIcon',
  CalcParamStateIcon = 'CalcParamStateIcon',
  WgParamIcon = 'WgParamIcon',
  Icon = 'Icon',
  DeviceParamFailureLog = 'DeviceParamFailureLog',
  CalcParamStateLog = 'CalcParamStateLog',
  DeviceParamStateLog = 'DeviceParamStateLog',
  ControllerLossLog = 'ControllerLossLog',
  ParamTag = 'ParamTag',
  Map = 'Map',
  Port = 'Port',
  ExpImp = 'ExpImp',
  Export = 'Export',
  Import = 'Import',
  Db = 'Db',
  Favorites = 'Favorites',
  Profile = 'Profile',
  Operatingmode = 'Operatingmode',
  Objectholiday = 'Objectholiday',
  Object_Status = 'Object_Status',
  Update = 'Update',
  Paramon = 'Paramon',
  Scheduletemplate = 'Scheduletemplate',
  Calendartemplate = 'Calendartemplate',
  Calendar = 'Calendar',
  CalendarHoliday = 'CalendarHoliday',
  Ruleon = 'Ruleon',
  Cdp = 'Cdp',
  Ccp = 'Ccp',
  Activity = 'Activity',
  Child = 'Child',
  Proc = 'Proc',
  LockedReason = 'LockedReason',
  Sensorlocation = 'Sensorlocation',
  ObjectState = 'ObjectState',
  ExtSystem = 'ExtSystem',
  TypicalProblem = 'TypicalProblem',
  Problem = 'Problem',
  Attr = 'Attr',
  ObjrubricAttr = 'ObjrubricAttr',
  SysUserAttr = 'SysUserAttr',
  Contact = 'Contact',
  Branding = 'Branding',
  v2 = 'v2',
  Verify = 'Verify',
  xterm = 'xterm',
  Company = 'Company',
  UserCompany = 'UserCompany',
  Search = 'search',
  Params = 'params',
  BusinessParamFailureLog = 'BusinessParamFailureLog',
  eventdwh = 'eventdwh',
  businessparam = 'businessparam',
  paramstate = 'paramstate',
  geozone = 'geozone',
  dwh = 'dwh',
  'GlobalRule' = 'GlobalRule',
  'Application' = 'Application',
}
